import { DatePipe, registerLocaleData } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import localeHr from '@angular/common/locales/hr';
import moment from 'moment';

registerLocaleData(localeHr);

@Pipe({
  pure: false,
  standalone: true,
  name: 'localizedDate'
})
export class LocalizedDatePipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(value: any, pattern: string = 'shortDate'): any {
    if (value) {
      const utc = moment.utc(value, 'DD-MM-YYYY HH:mm:ss').toDate();
      const local = moment(utc)
        .local()
        .format('YYYY-MM-DD HH:mm:ss');
      if (!this.translateService.currentLang) {
        this.translateService.currentLang = localStorage.getItem('language')
          ? localStorage.getItem('language')
          : 'en';
      }
      const datePipe: DatePipe = new DatePipe(
        this.translateService.currentLang
      );

      return datePipe.transform(local, pattern);
    }
  }
}
